import type React from 'react';
import { MoonLoader } from 'react-spinners';

type SpinnerProps = {
    color?: string;
    loading?: boolean;
    className?: string;
    speedMultiplier?: number;
};

const SmallSpinner: React.FC<SpinnerProps> = ({
    color = '#2970ff',
    loading = true,
    className,
    speedMultiplier = 1,
}) => {
    return (
        <MoonLoader
            size={10}
            color={color}
            loading={loading}
            speedMultiplier={speedMultiplier}
            className={className}
        />
    );
};

export default SmallSpinner;
